import React from "react";

import CategoryIcon from "./CategoryIcon";
import { CATEGORIES } from "../notificationCategories";
import { routeForTarget } from "../notificationRouting";

const NotificationRow = ({ item, marking, disabled, onOpen }) => {
  const category = CATEGORIES[item.categoryKey] || CATEGORIES.GENERAL;
  const navigable = Boolean(routeForTarget(item.target));

  return (
    <li
      className={`nt-row${item.read ? " is-read" : " is-unread"}${
        navigable ? " is-navigable" : ""
      }`}
    >
      <button
        type="button"
        className="nt-row-hit"
        disabled={disabled && !marking}
        onClick={() => onOpen(item)}
      >
        <CategoryIcon categoryKey={item.categoryKey} />

        <span className="nt-row-body">
          <span className="nt-row-title">
            <strong>{item.title}</strong>

            {marking ? (
              <span className="nt-spinner" aria-label="Opening" />
            ) : (
              !item.read && <span className="nt-dot" aria-label="Unread" />
            )}
          </span>

          {item.body && <span className="nt-row-text">{item.body}</span>}

          <span className="nt-row-meta">
            <span>{category.label}</span>
            <i />
            <span>{item.stamp}</span>
          </span>
        </span>
      </button>
    </li>
  );
};

export default NotificationRow;
